(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["delivery-rates"] && !Shopify.designMode) return;
  try {
    (() => {
    const initialise = () => {
      const root = document.getElementById('delivery-rates');
      if (!root || root.dataset.ready) return;
      root.dataset.ready = 'true';
      const destination = root.querySelector('[data-delivery-destination]');
      const currency = root.querySelector('[data-display-currency-select]');
      const result = root.querySelector('.delivery-rate-result');
      const carrier = root.querySelector('[data-delivery-carrier]');
      const weight = root.querySelector('[data-delivery-weight]');
      const error = root.querySelector('.delivery-currency-error');
      let lastDestination = null;
      const update = () => {
        const option = destination.selectedOptions[0];
        const local = option.value === 'uae';
        const known = option.value && option.value !== 'other';
        const prices = (option.dataset.dhlPrices || '').split(',').filter(Boolean).map(Number);
        const dhlAvailable = prices.length === 14;
        const aramexPrices = (option.dataset.aramexPrices || '').split(',').filter(Boolean).map(Number);
        const gcc = ['om', 'bh', 'qa', 'sa', 'kw'].includes(option.value);
        const europe = ["al","ad","at","by","be","ba","bg","hr","cy","cz","dk","ee","fo","fi","fr","de","gi","gr","gg","hu","is","ie","im","it","je","xk","lv","li","lt","lu","mt","md","mc","me","nl","mk","no","pl","pt","ro","ru","sm","rs","sk","si","es","sj","se","ch","ua","gb","va"].includes(option.value);
        const aramexTransit = gcc ? carrier.dataset.aramexGcc : carrier.dataset.aramexOther;
        const preferred = ' · ' + carrier.dataset.preferredText;
        if (lastDestination !== option.value) {
          carrier.value = europe && dhlAvailable ? 'dhl' : 'aramex';
          lastDestination = option.value;
        }
        carrier.querySelector('option[value="aramex"]').textContent = known && !local ? 'Aramex' + (gcc ? preferred : '') : 'Aramex';
        carrier.querySelector('option[value="dhl"]').textContent = dhlAvailable ? 'DHL' + (europe ? preferred : '') : 'DHL';
        carrier.querySelector('option[value="dhl"]').disabled = !dhlAvailable;
        if (!dhlAvailable) carrier.value = 'aramex';
        const dhl = known && !local && carrier.value === 'dhl';
        root.querySelector('[data-delivery-carrier-controls]').hidden = !known || local;
        weight.querySelectorAll('option').forEach(el => { el.disabled = !dhl && Number(el.value) > 10; el.hidden = el.disabled; });
        if (!dhl && Number(weight.value) > 10) weight.value = '10';
        root.querySelector('[data-delivery-weight-control]').hidden = !known || local;
        result.hidden = !known;
        root.querySelector('.delivery-unlisted').hidden = option.value !== 'other';
        root.querySelectorAll('[data-delivery-international]').forEach(el => el.hidden = !known || local);
        root.querySelectorAll('[data-delivery-local]').forEach(el => el.hidden = !local);
        if (known) {
          const transit = root.querySelector('[data-delivery-transit]');
          transit.textContent = local ? transit.dataset.localTransit : dhl ? option.dataset.dhlLabel : aramexTransit;
          ['first'].forEach(key => {
            const amount = root.querySelector('[data-delivery-' + key + ']');
            const value = local ? Number(option.dataset.first) : dhl ? prices[[1,2,3,4,5,6,7,8,9,10,15,20,25,30].indexOf(Number(weight.value))] : aramexPrices[Number(weight.value) - 1];
            amount.dataset.money = String(value);
            amount.textContent = 'AED ' + value / 100;
          });
        }
        window.districtCurrency?.render();
      };
      destination.addEventListener('change', update);
      carrier.addEventListener('change', update);
      weight.addEventListener('change', update);
      currency.addEventListener('change', async () => {
        const requested = currency.value;
        currency.disabled = true;
        error.hidden = true;
        try {
          if (!window.districtCurrency?.choose) throw new Error();
          await window.districtCurrency.choose(requested, false);
          window.districtCurrency.render();
          error.hidden = currency.value === requested;
        } catch {
          window.districtCurrency?.render();
          error.hidden = false;
        } finally {
          currency.disabled = false;
        }
      });
      update();
      const showRates = () => {
        if (window.location.hash === '#delivery-rates') {
          root.open = true;
          root.scrollIntoView({block: 'start'});
        }
      };
      showRates();
      window.addEventListener('hashchange', showRates);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, {once: true});
    else initialise();
  })();
  } catch(e) { console.error(e); }
})();

})();
